/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../../../../../webgl/BufferObject.js";
import "../../../../../webgl/FramebufferObject.js";
import "../../../../../../core/has.js";
import "../../../../../webgl/checkWebGLError.js";
import "../../../../../webgl/enums.js";
import "../../../../../../chunks/builtins.js";
import r from "../../../../../webgl/ShaderCompiler.js";
import "../../../../../webgl/Texture.js";
import "../../../../../webgl/VertexArrayObject.js";
import e from "./shaderRepository.js";

function t(r) {
  var t = e;
  return r.split("/").forEach(function (r) {
    t && (t = t[r]);
  }), t;
}

var o = new r(t);

function s(r) {
  return o.resolveIncludes(r);
}

export { s as resolveIncludes };